import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './NotebookPasteTextPopup.css';
import NotebookLang from './NotebookLang.json';

class NotebookPasteTextPopup extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookID: 0,
			notebookJsonObj: null,
			filename: "",
			fileText: "",
			dialogTitle: "",
			sourceIndex: -100,
		}
	}
		
	async componentDidMount() {
	}

	async componentDidUpdate() {

		var notebookID1 = this.state.notebookID;
		var notebookID2 = this.props.notebookID;
		
		if (notebookID2 === 0) {
			return;
		}

		var sourceIndex1 = this.state.sourceIndex;
		var sourceIndex2 = this.props.sourceIndex;

		if (notebookID1 === notebookID2) {
			if (sourceIndex1 === sourceIndex2) {
				return;
			}
		}

		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID2);

		var sourceArray = this.props.sourceArray;
		
		var dialogTitle = this.props.getLang(NotebookLang, "pasteText");
		var pasteTextYN = true;
		var fileText = "";
		var filename = "";

		if (sourceIndex2 >= 0) {
			var itemObj = sourceArray[sourceIndex2];
			var filenameExt = itemObj.filename;
			filename = filenameExt.substring(0, filenameExt.length-4);
			dialogTitle = this.props.getLang(NotebookLang, "editText") + " - " + filenameExt;
			pasteTextYN = false;
			var storageID = notebookJsonObj.storageID;
			fileText = await this.serverDownloadTextFileFromGoogleStorage(storageID, filenameExt);
		}
		
		this.setState({
			notebookJsonObj: notebookJsonObj,
			notebookID: notebookID2,
			sourceIndex: sourceIndex2,
			dialogTitle: dialogTitle,
			pasteTextYN: pasteTextYN,
			filename: filename,
			fileText: fileText,
		});
	}
	
	getExtFromFilename(filename) {
		var ext = filename.substr(filename.lastIndexOf('.') + 1);
		return ext.toLowerCase();
	}

	onPopUpClosed() {
		this.props.setNotebookPasteTextPopupYN(false);
	}

	async serverDownloadTextFileFromGoogleStorage(storageID, filename) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/downloadtextfilefromgooglestorage?storageid=" + encodeURIComponent(storageID);
		url = url + "&filename=" + encodeURIComponent(filename);

		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
			console.error(err);
		}

		return responseText;
	}

	async serverUploadFile(notebookID, storageID, companyID, userID, userFullName, filename, fileText) {
		
		var filenameExt = filename + ".txt";
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/uploadfile?notebookid=" + notebookID;
		url = url + "&storageid=" + encodeURIComponent(storageID);
		url = url + "&filename=" + encodeURIComponent(filenameExt);
		url = url + "&companyid=" + companyID;
		url = url + "&userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		
		var formData = new FormData();
		formData.append('fileText', fileText);

		var responseText = "";
		
		try {
			var res = await fetch(url, {
				method: 'POST',
				body: formData
			});

			responseText = await res.text();
		} catch (err) {
		}
		
		if (responseText === "") {
			this.props.showToast("ERROR - Unknown error occured");
			return;
		}

		return responseText;
	}

	async onClickSaveButton() {
		
		var filename = this.state.filename;
		filename = filename.trim();
		if (filename === "") {
			this.props.showToast(this.props.getLang(NotebookLang, "filenameIsEmpty"));
			return;
		}
		
		var notebookID = this.state.notebookID;
		var notebookJsonObj = this.state.notebookJsonObj;
		var storageID = notebookJsonObj.storageID;
		var companyID = this.props.companyID;
		var userID = this.props.userID;
		var fullName = this.props.fullName;
		var fileText = this.state.fileText;
		
		await this.serverUploadFile(notebookID, storageID, companyID, userID, fullName, filename, fileText);
		//var toastString = this.props.getLang(NotebookLang, "notebookTitleSaved");
		//this.props.showToast(toastString);
		this.onPopUpClosed();
		this.props.refreshData();
	}
	
	onClickCancelButton() {
		this.onPopUpClosed();
	}
	
	onFilenameChanged(filename) {
		this.setState({filename: filename});
	}
	
	onFileTextChanged(fileText) {
		this.setState({fileText: fileText});
	}
	
	renderButtons() {
		
		var notebookCreateYN = this.state.notebookCreateYN;
		if (notebookCreateYN) {
			//return;
		}

		return (
			<div className="ViewContainerButtons2">
				<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(NotebookLang, "cancel")}</button>
				<div style={{width: "20px"}}></div>
				<button className="ViewSaveButton" onClick={() => this.onClickSaveButton()}>{this.props.getLang(NotebookLang, "save")}</button>
			</div>
		);
	}
	
	renderContent() {

		var dialogTitle = this.state.dialogTitle;
		var pasteTextYN = this.state.pasteTextYN;
		var fileText = this.state.fileText;

		var sourceIndex1 = this.state.sourceIndex;
		var sourceIndex2 = this.props.sourceIndex;
		
		if (sourceIndex1 !== sourceIndex2) {
			dialogTitle = this.props.getLang(NotebookLang, "editText");
			fileText = "";
		}
		
		return (
			<div className="NotebookPasteTextPopupTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="NotebookPasteTextPopupTitle">{dialogTitle}</div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "10px"}}></div>
				<div className="NotebookPasteTextInputContainer">
					{pasteTextYN && (<input
						className="NotebookPasteTextFilename" 
						id="filename"
						type="text"
						value={this.state.filename}
						placeholder="Filename"
						onChange={(event) => this.onFilenameChanged(event.target.value)}
					/>)}
					{pasteTextYN && (<div style={{height: "20px"}}></div>)}
					<textarea
						className="NotebookPasteTextFileText" 
						id="fileText"
						type="text"
						value={fileText}
						rows="25"
						cols="100"
						onChange={(event) => this.onFileTextChanged(event.target.value)}
					/>
				</div>
				<div style={{height: "20px"}}></div>
				{this.renderButtons()}
				<div style={{height: "30px"}}></div>
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		return (
			<Popup
				className="notebook-paste-text-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default NotebookPasteTextPopup;


